export enum StatusIndicator {
    NotApplicable = 0,
    Danger = 1,
    Warning = 2,
    Success = 3,
    Info = 4
}
